import { useCurrentUserStore } from '@/features/currentUser/presentation/stores/currentUserStore'
import { useToastStore } from '@/shared/stores/useToastStore'
import type { ApiRequestOptions } from '@/backend/auth/core/ApiRequestOptions'

export interface PolicyMapping {
  [key: string]: string[] // URL pattern -> required policies
}

// Auto-generated policy mappings for auth service
export const authPolicyMapping: PolicyMapping = {
  "/api/admin/v1/baseroles": [
    "ReadBaseRole"
  ],
  "/api/admin/v1/otpconfigurations": [
    "ReadOtpConfiguration"
  ],
  "POST:/api/admin/v1/otpconfigurations": [
    "WriteOtpConfiguration"
  ],
  "/api/admin/v1/otprequests": [
    "ReadOtpRequest"
  ],
  "POST:/api/admin/v1/panelusers": [
    "WritePanelUser"
  ],
  "/api/admin/v1/panelusers": [
    "ReadPanelUser"
  ],
  "/api/admin/v1/regions": [
    "ReadRegion"
  ],
  "POST:/api/admin/v1/regions": [
    "WriteRegion"
  ],
  "/api/admin/v1/servicepanels": [
    "ReadServicePanel"
  ],
  "POST:/api/admin/v1/testphones": [
    "WriteTestPhone"
  ],
  "/api/admin/v1/testphones": [
    "ReadTestPhone"
  ],
  "POST:/api/admin/v1/users": [
    "WriteUser"
  ],
  "/api/admin/v1/users": [
    "ReadUser"
  ],
  "/api/admin/v1/users/{userId}/roles": [
    "ReadBaseRole"
  ],
  "/api/admin/v1/users/current/roles": [
    "ReadBaseRole"
  ],
  "/api/admin/v1/users/count": [
    "ReadCountry"
  ],
  "PUT:/api/admin/v1/users/{userId}/update": [
    "UpdateUserPassword"
  ],
  "DELETE:/api/admin/v1/users/delete": [
    "DeleteRegion"
  ]
}

// Auto-generated policy mappings for market service  
export const marketPolicyMapping: PolicyMapping = {
  "/api/admin/v1/adjustmentreasons": [
    "ViewAdjustmentReasons"
  ],
  "POST:/api/admin/v1/adjustmentreasons": [
    "ManageAdjustmentReasons"
  ],
  "PUT:/api/admin/v1/adjustmentreasons/{id}": [
    "ManageAdjustmentReasons"
  ],
  "DELETE:/api/admin/v1/adjustmentreasons/{id}": [
    "ManageAdjustmentReasons"
  ],
  "/api/driver/v1/adjustments": [
    "ViewAdjustments"
  ],
  "/api/admin/v1/adjustments": [
    "ViewAdjustments"
  ],
  "POST:/api/admin/v1/adjustments": [
    "ManageAdjustments"
  ],
  "/api/admin/v1/adjustments/{id}": [
    "ViewAdjustmentDetails"
  ],
  "PUT:/api/admin/v1/adjustments/{id}": [
    "ManageAdjustments"
  ],
  "DELETE:/api/admin/v1/adjustments/{id}": [
    "DeleteAdjustments"
  ],
  "/api/admin/v1/auditentries": [
    "ViewActivityLogs"
  ],
  "/api/admin/v1/baseroles/{id}": [
    "ViewBaseRoles"
  ],
  "PUT:/api/admin/v1/baseroles/{id}": [
    "ManageBaseRoles"
  ],
  "/api/admin/v1/baseroles": [
    "ViewBaseRoles"
  ],
  "/api/admin/v1/branchdeliverysystems": [
    "ViewBranchDeliverySystems"
  ],
  "POST:/api/admin/v1/branchdeliverysystems": [
    "ManageBranchDeliverySystems"
  ],
  "/api/admin/v1/branchdeliverysystems/{branchDeliverySystemId}": [
    "ViewBranchDeliverySystems"
  ],
  "PUT:/api/admin/v1/branchdeliverysystems/{branchDeliverySystemId}": [
    "ManageBranchDeliverySystems"
  ],
  "DELETE:/api/admin/v1/branchdeliverysystems/{branchDeliverySystemId}": [
    "DeleteBranchDeliverySystems"
  ],
  "/api/partner/v1/branches/public/search": [
    "ViewSearchSettings"
  ],
  "/api/partner/v1/branches/public/public/search": [
    "ViewSearchSettings"
  ],
  "/api/operator/v1/branches": [
    "ViewBranches"
  ],
  "/api/client/v1/branches/search": [
    "ViewSearchSettings"
  ],
  "/api/client/v1/branches/public/search": [
    "ViewSearchSettings"
  ],
  "/api/admin/v1/branches/{id}": [
    "ViewBranchDetails"
  ],
  "DELETE:/api/admin/v1/branches/{id}": [
    "DeleteBranches"
  ],
  "PUT:/api/admin/v1/branches/{id}": [
    "ManageBranches"
  ],
  "POST:/api/admin/v1/branches/{id}/submit-to-zoho": [
    "ManageBranches"
  ],
  "/api/admin/v1/branches/{id}/generic-zoho-values": [
    "ViewBranchDetails"
  ],
  "PUT:/api/admin/v1/branches/{id}/generic-zoho-values": [
    "ManageBranchZohoValues"
  ],
  "/api/admin/v1/branches/{branchId}/categories": [
    "ViewCategories"
  ],
  "/api/admin/v1/branches/{id}/districts": [
    "ViewBranchDetails"
  ],
  "PUT:/api/admin/v1/branches/{id}/districts": [
    "ManageBranchDistricts"
  ],
  "/api/admin/v1/branches": [
    "ViewBranches"
  ],
  "POST:/api/admin/v1/branches": [
    "ManageBranches"
  ],
  "/api/admin/v1/branches/{id}/status-logs": [
    "ViewBranchStatusLogs"
  ],
  "/api/admin/v1/branches/{id}/disable-logs": [
    "ViewBranchDetails"
  ],
  "/api/admin/v1/branches/{branchId}/users": [
    "ViewBranchDetails"
  ],
  "PUT:/api/admin/v1/branches/{branchId}/users": [
    "ManageBranches"
  ],
  "/api/admin/v1/branches/{branchId}/branch-tags": [
    "ViewBranchDetails"
  ],
  "PUT:/api/admin/v1/branches/{branchId}/branch-tags": [
    "ManageBranchBranchTags"
  ],
  "POST:/api/admin/v1/branches/{id}/disable": [
    "ManageBranches"
  ],
  "POST:/api/admin/v1/branches/{id}/enable": [
    "ManageBranches"
  ],
  "PUT:/api/admin/v1/branches/{id}/vip": [
    "ManageBranchVip"
  ],
  "POST:/api/admin/v1/branches/sync": [
    "SyncAlgoliaBranches"
  ],
  "PUT:/api/admin/v1/branches/{id}/status": [
    "ManageBranches"
  ],
  "/api/admin/v1/branches/working": [
    "ManageBranches"
  ],
  "/api/admin/v1/branches/export": [
    "ExportBranchFiles"
  ],
  "/api/admin/v1/branches/export-local": [
    "ExportBranchFiles"
  ],
  "POST:/api/admin/v1/branches/{branchId}/import": [
    "ImportBranchFiles"
  ],
  "DELETE:/api/admin/v1/branches/{id}/menu": [
    "ManageBranches"
  ],
  "/api/admin/v1/branchminimumcartsystems": [
    "ViewBranchMinimumCartSystems"
  ],
  "POST:/api/admin/v1/branchminimumcartsystems": [
    "ManageBranchMinimumCartSystems"
  ],
  "/api/admin/v1/branchminimumcartsystems/{branchMinimumCartSystemId}": [
    "ViewBranchMinimumCartSystems"
  ],
  "PUT:/api/admin/v1/branchminimumcartsystems/{branchMinimumCartSystemId}": [
    "ManageBranchMinimumCartSystems"
  ],
  "DELETE:/api/admin/v1/branchminimumcartsystems/{branchMinimumCartSystemId}": [
    "DeleteBranchMinimumCartSystems"
  ],
  "/api/admin/v1/branchpins/{id}": [
    "ViewBranchPins"
  ],
  "PUT:/api/admin/v1/branchpins/{id}": [
    "ManageBranchPins"
  ],
  "DELETE:/api/admin/v1/branchpins/{id}": [
    "DeleteBranchPins"
  ],
  "/api/admin/v1/branchpins": [
    "ViewBranchPins"
  ],
  "POST:/api/admin/v1/branchpins": [
    "ManageBranchPins"
  ],
  "/api/admin/v1/branchshifts/{branchId}": [
    "ViewBranchShifts"
  ],
  "PUT:/api/admin/v1/branchshifts/{branchId}": [
    "ManageBranchShifts"
  ],
  "/api/client/v1/branchtags": [
    "ViewBranchTags"
  ],
  "/api/admin/v1/branchtags/{branchTagId}/branches": [
    "ViewBranchTagBranches"
  ],
  "PUT:/api/admin/v1/branchtags/{branchTagId}/branches": [
    "ManageBranchTags"
  ],
  "/api/admin/v1/branchtags/{id}": [
    "ViewBranchTags"
  ],
  "PUT:/api/admin/v1/branchtags/{id}": [
    "ManageBranchTags"
  ],
  "DELETE:/api/admin/v1/branchtags/{id}": [
    "DeleteBranchTags"
  ],
  "/api/admin/v1/branchtags": [
    "ViewBranchTags"
  ],
  "POST:/api/admin/v1/branchtags": [
    "ManageBranchTags"
  ],
  "/api/client/v1/brands": [
    "ViewBrands"
  ],
  "/api/admin/v1/brands/{id}": [
    "ViewBrandDetails"
  ],
  "PUT:/api/admin/v1/brands/{id}": [
    "ManageBrand"
  ],
  "DELETE:/api/admin/v1/brands/{id}": [
    "DeleteBrand"
  ],
  "/api/admin/v1/brands": [
    "ViewBrands"
  ],
  "POST:/api/admin/v1/brands": [
    "ManageBrand"
  ],
  "POST:/api/admin/v1/campaigns": [
    "ManageCampaign"
  ],
  "/api/admin/v1/campaigns": [
    "ViewCampaigns"
  ],
  "/api/admin/v1/campaigns/{id}": [
    "ViewCampaignDetails"
  ],
  "PUT:/api/admin/v1/campaigns/{id}": [
    "ManageCampaign"
  ],
  "DELETE:/api/admin/v1/campaigns/{id}": [
    "DeleteCampaign"
  ],
  "/api/admin/v1/campaigns/{id}/include-branches": [
    "ViewCampaigns"
  ],
  "PUT:/api/admin/v1/campaigns/{id}/include-branches": [
    "ManageCampaign"
  ],
  "/api/admin/v1/campaigns/{id}/excluded-branches": [
    "ViewCampaigns"
  ],
  "PUT:/api/admin/v1/campaigns/{id}/excluded-branches": [
    "ManageCampaign"
  ],
  "/api/admin/v1/campaigns/{id}/users": [
    "ViewCampaigns"
  ],
  "PUT:/api/admin/v1/campaigns/{id}/users": [
    "ManageCampaign"
  ],
  "/api/admin/v1/campaigns/{id}/groups": [
    "ViewCampaigns"
  ],
  "PUT:/api/admin/v1/campaigns/{id}/groups": [
    "ManageCampaign"
  ],
  "/api/admin/v1/campaigns/{id}/channels": [
    "ViewCampaigns"
  ],
  "PUT:/api/admin/v1/campaigns/{id}/channels": [
    "ManageCampaign"
  ],
  "/api/admin/v1/campaigns/{id}/regions": [
    "ViewCampaigns"
  ],
  "PUT:/api/admin/v1/campaigns/{id}/regions": [
    "ManageCampaign"
  ],
  "/api/admin/v1/campaigns/{id}/services": [
    "ViewCampaigns"
  ],
  "PUT:/api/admin/v1/campaigns/{id}/services": [
    "ManageCampaign"
  ],
  "/api/admin/v1/canceldeliveryreasons/{id}": [
    "ViewCancelDeliveryReasons"
  ],
  "PUT:/api/admin/v1/canceldeliveryreasons/{id}": [
    "ManageCancelDeliveryReasons"
  ],
  "DELETE:/api/admin/v1/canceldeliveryreasons/{id}": [
    "DeleteCancelDeliveryReasons"
  ],
  "/api/admin/v1/canceldeliveryreasons": [
    "ViewCancelDeliveryReasons"
  ],
  "POST:/api/admin/v1/canceldeliveryreasons": [
    "ManageCancelDeliveryReasons"
  ],
  "/api/admin/v1/canceledorders/{id}": [
    "ViewCanceledOrders"
  ],
  "/api/admin/v1/canceledorders/order/{orderId}": [
    "ViewCanceledOrders"
  ],
  "/api/admin/v1/canceledorders": [
    "ViewCanceledOrders"
  ],
  "/api/admin/v1/cancelmealreasons/{id}": [
    "ViewCancelMealReasons"
  ],
  "PUT:/api/admin/v1/cancelmealreasons/{id}": [
    "ManageCancelMealReasons"
  ],
  "DELETE:/api/admin/v1/cancelmealreasons/{id}": [
    "DeleteCancelMealReasons"
  ],
  "/api/admin/v1/cancelmealreasons": [
    "ViewCancelMealReasons"
  ],
  "POST:/api/admin/v1/cancelmealreasons": [
    "ManageCancelMealReasons"
  ],
  "/api/operator/v1/cancelorderreasons": [
    "ViewCancelOrderReasons"
  ],
  "/api/client/v1/cancelorderreasons": [
    "ViewCancelOrderReasons"
  ],
  "/api/admin/v1/cancelorderreasons/{id}": [
    "ViewCancelOrderReasons"
  ],
  "PUT:/api/admin/v1/cancelorderreasons/{id}": [
    "ManageCancelOrderReasons"
  ],
  "DELETE:/api/admin/v1/cancelorderreasons/{id}": [
    "DeleteCancelOrderReasons"
  ],
  "/api/admin/v1/cancelorderreasons": [
    "ViewCancelOrderReasons"
  ],
  "POST:/api/admin/v1/cancelorderreasons": [
    "ManageCancelOrderReasons"
  ],
  "/api/admin/v1/cancelpackagereasons/{id}": [
    "ViewCancelPackageReasons"
  ],
  "PUT:/api/admin/v1/cancelpackagereasons/{id}": [
    "ManageCancelPackageReasons"
  ],
  "DELETE:/api/admin/v1/cancelpackagereasons/{id}": [
    "DeleteCancelPackageReasons"
  ],
  "/api/admin/v1/cancelpackagereasons": [
    "ViewCancelPackageReasons"
  ],
  "POST:/api/admin/v1/cancelpackagereasons": [
    "ManageCancelPackageReasons"
  ],
  "/api/driver/v1/cancelshipmentreasons": [
    "ViewCancelShipmentReasons"
  ],
  "POST:/api/admin/v1/cancelshipmentreasons": [
    "ManageCancelShipmentReasons"
  ],
  "/api/admin/v1/cancelshipmentreasons": [
    "ViewCancelShipmentReasons"
  ],
  "/api/admin/v1/cancelshipmentreasons/simplified": [
    "ViewCancelShipmentReasons"
  ],
  "/api/admin/v1/cancelshipmentreasons/{id}": [
    "ViewCancelShipmentReasons"
  ],
  "PUT:/api/admin/v1/cancelshipmentreasons/{id}": [
    "ManageCancelShipmentReasons"
  ],
  "DELETE:/api/admin/v1/cancelshipmentreasons/{id}": [
    "DeleteCancelShipmentReasons"
  ],
  "/api/client/v1/cards": [
    "ViewCards"
  ],
  "/api/admin/v1/cards/{id}": [
    "ViewCardDetails"
  ],
  "PUT:/api/admin/v1/cards/{id}": [
    "ManageCards"
  ],
  "DELETE:/api/admin/v1/cards/{id}": [
    "DeleteCards"
  ],
  "/api/admin/v1/cards": [
    "ViewCards"
  ],
  "POST:/api/admin/v1/cards": [
    "ManageCards"
  ],
  "PUT:/api/admin/v1/cards/order/{id}": [
    "ManageCards"
  ],
  "/api/driver/v1/cargos/activity": [
    "ViewActivityLogs"
  ],
  "/api/admin/v1/cargos/{id}": [
    "ViewOrderDetails"
  ],
  "POST:/api/admin/v1/cargos/{id}/cancel": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/cargos/{id}/transfer-and-acquire": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/cargos/{id}/transfer-and-assign": [
    "ManageMeals"
  ],
  "/api/client/v1/carts": [
    "ViewBranchMinimumCartSystems"
  ],
  "POST:/api/admin/v1/cashback-offers": [
    "ManageCashbackOffers"
  ],
  "/api/admin/v1/cashback-offers": [
    "ViewCashbackOffers"
  ],
  "/api/admin/v1/cashback-offers/{id}": [
    "ViewCashbackOfferDetails"
  ],
  "PUT:/api/admin/v1/cashback-offers/{id}": [
    "ManageCashbackOffers"
  ],
  "DELETE:/api/admin/v1/cashback-offers/{id}": [
    "DeleteCashbackOffers"
  ],
  "/api/admin/v1/cashback-offers/{id}/users": [
    "ViewCashbackOffers"
  ],
  "PUT:/api/admin/v1/cashback-offers/{id}/users": [
    "ManageCashbackOffers"
  ],
  "/api/admin/v1/cashback-offers/{id}/groups": [
    "ViewCashbackOffers"
  ],
  "PUT:/api/admin/v1/cashback-offers/{id}/groups": [
    "ManageCashbackOffers"
  ],
  "/api/admin/v1/cashback-offers/{id}/channels": [
    "ViewCashbackOffers"
  ],
  "PUT:/api/admin/v1/cashback-offers/{id}/channels": [
    "ManageCashbackOffers"
  ],
  "/api/admin/v1/cashback-offers/{id}/services": [
    "ViewCashbackOffers"
  ],
  "PUT:/api/admin/v1/cashback-offers/{id}/services": [
    "ManageCashbackOffers"
  ],
  "/api/admin/v1/cashback-offers/{id}/include-branches": [
    "ViewCashbackOffers"
  ],
  "PUT:/api/admin/v1/cashback-offers/{id}/include-branches": [
    "ManageCashbackOffers"
  ],
  "/api/admin/v1/cashback-offers/{id}/excluded-branches": [
    "ViewCashbackOffers"
  ],
  "PUT:/api/admin/v1/cashback-offers/{id}/excluded-branches": [
    "ManageCashbackOffers"
  ],
  "/api/admin/v1/cashback-offers/{id}/regions": [
    "ViewCashbackOffers"
  ],
  "PUT:/api/admin/v1/cashback-offers/{id}/regions": [
    "ManageCashbackOffers"
  ],
  "POST:/api/admin/v1/cashback-offers/{id}/branches/import": [
    "ManageCashbackOffers"
  ],
  "/api/admin/v1/cashback-offers/{id}/variations": [
    "ViewCashbackOffers"
  ],
  "PUT:/api/admin/v1/cashback-offers/{id}/variations": [
    "ManageCashbackOffers"
  ],
  "/api/admin/v1/cashback-offers/{id}/branch-ratios": [
    "ViewCashbackOffers"
  ],
  "PUT:/api/admin/v1/cashback-offers/{id}/branch-ratios": [
    "ManageCashbackOffers"
  ],
  "/api/client/v1/categories": [
    "ViewCategories"
  ],
  "/api/admin/v1/categories": [
    "ViewCategories"
  ],
  "POST:/api/admin/v1/categories": [
    "ManageCategories"
  ],
  "/api/admin/v1/categories/all": [
    "ViewCategories"
  ],
  "/api/admin/v1/categories/{id}": [
    "ViewCategoryDetails"
  ],
  "PUT:/api/admin/v1/categories/{id}": [
    "ManageCategories"
  ],
  "DELETE:/api/admin/v1/categories/{id}": [
    "DeleteCategories"
  ],
  "PUT:/api/admin/v1/categories/{id}/order": [
    "ManageCategories"
  ],
  "/api/client/v1/channels": [
    "ViewChannels"
  ],
  "POST:/api/admin/v1/channels": [
    "ManageChannels"
  ],
  "/api/admin/v1/channels": [
    "ViewChannels"
  ],
  "/api/admin/v1/channels/{id}": [
    "ViewChannelDetails"
  ],
  "PUT:/api/admin/v1/channels/{id}": [
    "ManageChannels"
  ],
  "DELETE:/api/admin/v1/channels/{id}": [
    "DeleteChannels"
  ],
  "/api/admin/v1/channels/{channelId}/channel-service-zoho-accounts": [
    "ViewChannelDetails"
  ],
  "/api/admin/v1/channels/{channelId}/channel-service-zoho-accounts/{serviceId}/generic-zoho-values": [
    "ViewChannelDetails"
  ],
  "POST:/api/admin/v1/channels/{channelId}/channel-service-zoho-accounts/{serviceId}/generic-zoho-values": [
    "ManageChannels"
  ],
  "DELETE:/api/admin/v1/channels/{channelId}/channel-service-zoho-accounts/{serviceId}/generic-zoho-values": [
    "ManageChannels"
  ],
  "/api/admin/v1/channels/all": [
    "ViewChannels"
  ],
  "PUT:/api/admin/v1/channels/layout": [
    "ManageChannelLayout"
  ],
  "/api/admin/v1/channels/layout/{regionId}": [
    "ViewChannelLayout"
  ],
  "/api/admin/v1/channels/{id}/regions": [
    "ViewChannelDetails"
  ],
  "PUT:/api/admin/v1/channels/{id}/regions": [
    "ManageChannels"
  ],
  "/api/admin/v1/channels/{regionId}/order-regions": [
    "ViewChannelDetails"
  ],
  "PUT:/api/admin/v1/channels/{regionId}/order-regions": [
    "ManageChannels"
  ],
  "/api/admin/v1/channelusers/{id}": [
    "ViewChannelUsers"
  ],
  "PUT:/api/admin/v1/channelusers/{id}": [
    "ManageChannelUsers"
  ],
  "DELETE:/api/admin/v1/channelusers/{id}": [
    "DeleteChannelUsers"
  ],
  "/api/admin/v1/channelusers/user/{id}": [
    "ViewChannelUsers"
  ],
  "/api/admin/v1/channelusers": [
    "ViewChannelUsers"
  ],
  "POST:/api/admin/v1/channelusers": [
    "ManageChannelUsers"
  ],
  "/api/admin/v1/channelusers/current": [
    "ViewDriverCurrentOrders"
  ],
  "/api/admin/v1/channelworkinghours/{channelId}/regions/{regionId}": [
    "ViewChannelWorkingHours"
  ],
  "PUT:/api/admin/v1/channelworkinghours/{channelId}/regions/{regionId}/shifts": [
    "ManageChannelWorkingHours"
  ],
  "PUT:/api/admin/v1/channelworkinghours/{channelId}/regions/{regionId}/status": [
    "ManageChannelWorkingHours"
  ],
  "/api/client/v1/companies/current": [
    "ViewDriverCurrentOrders"
  ],
  "/api/admin/v1/companies/{id}": [
    "ViewCompanies"
  ],
  "PUT:/api/admin/v1/companies/{id}": [
    "ManageCompanies"
  ],
  "DELETE:/api/admin/v1/companies/{id}": [
    "ManageCompanies"
  ],
  "/api/admin/v1/companies": [
    "ViewCompanies"
  ],
  "POST:/api/admin/v1/companies": [
    "ManageCompanies"
  ],
  "PUT:/api/admin/v1/companies/{id}/periods": [
    "ManageCompanies"
  ],
  "/api/admin/v1/companies/{id}/periods": [
    "ManageCompanies"
  ],
  "/api/admin/v1/companies/{id}/subscriptions": [
    "ViewSubscriptions"
  ],
  "POST:/api/admin/v1/companies/{id}/subscriptions": [
    "ManageSubscriptions"
  ],
  "PUT:/api/admin/v1/companies/subscriptions/{id}": [
    "ManageSubscriptions"
  ],
  "/api/admin/v1/companies/{id}/branches": [
    "ViewCompanyBranches"
  ],
  "PUT:/api/admin/v1/companies/{id}/branches": [
    "ManageCompanyBranches"
  ],
  "PUT:/api/admin/v1/companies/{id}/disability": [
    "ManageCompanies"
  ],
  "/api/client/v1/companyusers/current": [
    "ViewDriverCurrentOrders"
  ],
  "/api/admin/v1/companyusers/{id}": [
    "ViewCompanyUsers"
  ],
  "PUT:/api/admin/v1/companyusers/{id}": [
    "ManageCompanyUsers"
  ],
  "DELETE:/api/admin/v1/companyusers/{id}": [
    "ManageCompanyUsers"
  ],
  "/api/admin/v1/companyusers": [
    "ViewCompanyUsers"
  ],
  "POST:/api/admin/v1/companyusers/bulk": [
    "ManageCompanyUsers"
  ],
  "/api/client/v1/coupons": [
    "ViewCoupons"
  ],
  "/api/admin/v1/coupons": [
    "ViewCoupons"
  ],
  "POST:/api/admin/v1/coupons": [
    "ManageCoupons"
  ],
  "/api/admin/v1/coupons/{id}": [
    "ViewCouponDetails"
  ],
  "PUT:/api/admin/v1/coupons/{id}": [
    "ManageCoupons"
  ],
  "DELETE:/api/admin/v1/coupons/{id}": [
    "DeleteCoupons"
  ],
  "/api/admin/v1/coupons/{id}/revelations": [
    "ViewCouponDetails"
  ],
  "/api/admin/v1/coupons/{id}/channels": [
    "ViewCouponDetails"
  ],
  "PUT:/api/admin/v1/coupons/{id}/channels": [
    "ManageCoupons"
  ],
  "/api/admin/v1/coupons/{id}/users": [
    "ViewCouponDetails"
  ],
  "PUT:/api/admin/v1/coupons/{id}/users": [
    "ManageCoupons"
  ],
  "/api/admin/v1/coupons/{id}/groups": [
    "ViewCouponDetails"
  ],
  "PUT:/api/admin/v1/coupons/{id}/groups": [
    "ManageCoupons"
  ],
  "/api/admin/v1/coupons/{id}/branches": [
    "ViewCouponDetails"
  ],
  "PUT:/api/admin/v1/coupons/{id}/branches": [
    "ManageCoupons"
  ],
  "/api/admin/v1/coupons/{id}/regions": [
    "ViewCouponDetails"
  ],
  "PUT:/api/admin/v1/coupons/{id}/regions": [
    "ManageCoupons"
  ],
  "/api/client/v1/custommessages": [
    "ViewCustomMessages"
  ],
  "/api/admin/v1/custommessages/{id}": [
    "ViewCustomMessageDetails"
  ],
  "PUT:/api/admin/v1/custommessages/{id}": [
    "ManageCustomMessage"
  ],
  "DELETE:/api/admin/v1/custommessages/{id}": [
    "DeleteCustomMessage"
  ],
  "/api/admin/v1/custommessages": [
    "ViewCustomMessages"
  ],
  "POST:/api/admin/v1/custommessages": [
    "ManageCustomMessage"
  ],
  "/api/admin/v1/custommessages/{id}/regions": [
    "ViewCustomMessageDetails"
  ],
  "PUT:/api/admin/v1/custommessages/{id}/regions": [
    "ManageCustomMessage"
  ],
  "/api/admin/v1/custommessages/{id}/districts": [
    "ViewCustomMessageDetails"
  ],
  "PUT:/api/admin/v1/custommessages/{id}/districts": [
    "ManageCustomMessage"
  ],
  "/api/admin/v1/custommessages/{id}/users": [
    "ViewCustomMessageDetails"
  ],
  "PUT:/api/admin/v1/custommessages/{id}/users": [
    "ManageCustomMessage"
  ],
  "/api/driver/v1/deliveries/activity": [
    "ViewActivityLogs"
  ],
  "/api/admin/v1/deliveries/{id}": [
    "ViewOrderDetails"
  ],
  "POST:/api/admin/v1/deliveries/{id}/cancel": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/deliverydiscounts": [
    "ManageBranchDeliveryDiscount"
  ],
  "/api/admin/v1/deliverydiscounts": [
    "ViewBranchDeliveryDiscount"
  ],
  "/api/admin/v1/deliverydiscounts/{id}": [
    "ViewBranchDeliveryDiscount"
  ],
  "PUT:/api/admin/v1/deliverydiscounts/{id}": [
    "ManageBranchDeliveryDiscount"
  ],
  "/api/admin/v1/deliverydiscounts/{id}/branches": [
    "ManageBranchDeliveryDiscount"
  ],
  "PUT:/api/admin/v1/deliverydiscounts/{id}/branches": [
    "ManageBranchDeliveryDiscount"
  ],
  "POST:/api/admin/v1/deliverydiscounts/{id}/branches/{branchId}": [
    "ManageBranchDeliveryDiscount"
  ],
  "DELETE:/api/admin/v1/deliverydiscounts/{id}/branches/{branchId}": [
    "ManageBranchDeliveryDiscount"
  ],
  "/api/admin/v1/diagnostics/memory": [
    "ViewActivityLogs"
  ],
  "POST:/api/admin/v1/disablebranchreasons": [
    "ManageDisableBranchReasons"
  ],
  "/api/admin/v1/disablebranchreasons": [
    "ViewDisableBranchReasons"
  ],
  "PUT:/api/admin/v1/disablebranchreasons/{id}": [
    "ManageDisableBranchReasons"
  ],
  "DELETE:/api/admin/v1/disablebranchreasons/{id}": [
    "DeleteDisableBranchReasons"
  ],
  "/api/admin/v1/disablebranchreasons/{id}": [
    "ViewDisableBranchReasonDetails"
  ],
  "POST:/api/admin/v1/discounts": [
    "ManageDiscounts"
  ],
  "/api/admin/v1/discounts": [
    "ViewDiscounts"
  ],
  "/api/admin/v1/discounts/{id}": [
    "ViewDiscountDetails"
  ],
  "PUT:/api/admin/v1/discounts/{id}": [
    "ManageDiscounts"
  ],
  "DELETE:/api/admin/v1/discounts/{id}": [
    "DeleteDiscounts"
  ],
  "/api/admin/v1/discounts/{id}/users": [
    "ViewDiscountDetails"
  ],
  "/api/admin/v1/discounts/{id}/groups": [
    "ViewDiscountDetails"
  ],
  "/api/admin/v1/discounts/{id}/categories": [
    "ViewDiscountDetails"
  ],
  "/api/admin/v1/discounts/{id}/items": [
    "ViewDiscountDetails"
  ],
  "POST:/api/admin/v1/discounts/branch-labels": [
    "DeleteDiscounts"
  ],
  "POST:/api/admin/v1/districts": [
    "ManageDistricts"
  ],
  "/api/admin/v1/districts/regions/{regionId}": [
    "ViewDistricts"
  ],
  "/api/admin/v1/districts/regions": [
    "ViewDistricts"
  ],
  "DELETE:/api/admin/v1/districts/{id}": [
    "DeleteDistricts"
  ],
  "PUT:/api/admin/v1/districts/{id}/disability": [
    "ManageDistricts"
  ],
  "/api/admin/v1/drivers/{driverId}/acceptance-rate": [
    "ViewDriverAcceptanceRate"
  ],
  "/api/admin/v1/drivers/{driverId}/acceptance-rate/{date}": [
    "ViewDriverAcceptanceRate"
  ],
  "POST:/api/admin/v1/driverblocks": [
    "ManageDriverBlocks"
  ],
  "/api/admin/v1/driverblocks": [
    "ViewDriverBlocks"
  ],
  "/api/admin/v1/driverblocks/{id}": [
    "ViewDriverBlocks"
  ],
  "PUT:/api/admin/v1/driverblocks/{id}": [
    "ManageDriverBlocks"
  ],
  "/api/admin/v1/driverblocks/driver/{driverId}/active": [
    "ViewDriverBlocks"
  ],
  "POST:/api/driver/v1/driverbreaks": [
    "ManageDriverBreaks"
  ],
  "/api/driver/v1/driverbreaks": [
    "ViewDriverBreaks"
  ],
  "/api/driver/v1/driverbreaks/current/active": [
    "ChangeOrderStatusWhenIsActive"
  ],
  "POST:/api/driver/v1/driverbreaks/{id}/cancel": [
    "ManageCancelOrderReasons"
  ],
  "/api/admin/v1/driverbreaks": [
    "ViewDriverBreaks"
  ],
  "POST:/api/admin/v1/driverbreaks": [
    "ManageDriverBreaks"
  ],
  "/api/admin/v1/driverbreaks/{id}": [
    "ViewDriverBreaks"
  ],
  "POST:/api/admin/v1/driverbreaks/{id}/approve": [
    "ManageDriverBreaks"
  ],
  "POST:/api/admin/v1/driverbreaks/{id}/reject": [
    "ManageDriverBreaks"
  ],
  "POST:/api/admin/v1/driverbreaks/{id}/cancel": [
    "ManageDriverBreaks"
  ],
  "POST:/api/admin/v1/driverbreaks/{id}/complete": [
    "ManageDriverBreaks"
  ],
  "POST:/api/admin/v1/driverdailymetrics/run-manually/validate": [
    "RunDriverDailyMetricsManually"
  ],
  "POST:/api/admin/v1/driverdailymetrics/run-manually": [
    "RunDriverDailyMetricsManually"
  ],
  "/api/admin/v1/driverdailymetrics": [
    "ViewDriverDailyMetrics"
  ],
  "/api/admin/v1/driverdailymetrics/{id}": [
    "ViewDriverDailyMetrics"
  ],
  "POST:/api/driver/v1/driverdayoffs": [
    "ManageDriverDayOffs"
  ],
  "/api/driver/v1/driverdayoffs": [
    "ViewDriverDayOffs"
  ],
  "/api/driver/v1/driverdayoffs/current/active": [
    "ChangeOrderStatusWhenIsActive"
  ],
  "POST:/api/driver/v1/driverdayoffs/{id}/cancel": [
    "ManageCancelOrderReasons"
  ],
  "/api/admin/v1/driverdayoffs": [
    "ViewDriverDayOffs"
  ],
  "POST:/api/admin/v1/driverdayoffs": [
    "ManageDriverDayOffs"
  ],
  "/api/admin/v1/driverdayoffs/{id}": [
    "ViewDriverDayOffs"
  ],
  "POST:/api/admin/v1/driverdayoffs/{id}/approve": [
    "ManageDriverDayOffs"
  ],
  "POST:/api/admin/v1/driverdayoffs/{id}/reject": [
    "ManageDriverDayOffs"
  ],
  "POST:/api/admin/v1/driverdayoffs/{id}/cancel": [
    "ManageDriverDayOffs"
  ],
  "POST:/api/admin/v1/driverdayoffs/{id}/complete": [
    "ManageDriverDayOffs"
  ],
  "/api/driver/v1/driverdocuments/driver/current": [
    "ViewDriverCurrentOrders"
  ],
  "POST:/api/admin/v1/driverdocuments": [
    "ManageDriverDocuments"
  ],
  "/api/admin/v1/driverdocuments/driver/{driverId}": [
    "ViewDriverDocuments"
  ],
  "/api/admin/v1/driverdocuments/missing-drivers": [
    "ViewDriverDocuments"
  ],
  "PUT:/api/admin/v1/driverdocuments/{documentId}": [
    "ManageDriverDocuments"
  ],
  "/api/driver/v1/driverearnings": [
    "ViewDriverEarning"
  ],
  "POST:/api/admin/v1/driver-earnings/comparison/stored-summary": [
    "ViewDriverEarning"
  ],
  "POST:/api/admin/v1/driver-earnings/comparison/reconstructed-summary": [
    "ViewDriverEarning"
  ],
  "/api/admin/v1/driver-earnings/comparison/jobs/{requestKey}": [
    "ViewDriverEarning"
  ],
  "/api/admin/v1/driver-earnings/debug/earning/{sourceType}/{sourceId}": [
    "ViewDriverEarning"
  ],
  "/api/admin/v1/driver-earnings/debug/batches/{batchId}": [
    "ViewDriverEarning"
  ],
  "/api/admin/v1/driver-earnings/debug/drivers/{driverId}": [
    "ViewDriverEarning"
  ],
  "/api/admin/v1/driver-earnings/debug/comparison/{sourceType}/{sourceId}": [
    "ViewDriverEarning"
  ],
  "POST:/api/admin/v1/driver-earnings/recalculate/source": [
    "ReCalculateDriverEarnings"
  ],
  "/api/admin/v1/driver-earnings/recovery/open-terminal-batches": [
    "ViewDriverEarning"
  ],
  "POST:/api/admin/v1/driver-earnings/recovery/open-terminal-batches/continue": [
    "ReCalculateDriverEarnings"
  ],
  "/api/admin/v1/driver-earnings/recovery/jobs/{requestKey}": [
    "ReCalculateDriverEarnings"
  ],
  "/api/admin/v1/driverhalts": [
    "ViewDriverHalts"
  ],
  "POST:/api/admin/v1/driverhalts/{driverId}/release": [
    "ManageDriverHalts"
  ],
  "POST:/api/admin/v1/driverhalts/{driverId}": [
    "ManageDriverHalts"
  ],
  "/api/admin/v1/drivermetricadjustments": [
    "ViewDriverMetricAdjustments"
  ],
  "/api/admin/v1/drivermetricadjustments/{id}": [
    "ViewDriverMetricAdjustments"
  ],
  "POST:/api/admin/v1/drivermetricadjustments/acceptance-rate": [
    "ManageDriverMetricAdjustments"
  ],
  "POST:/api/admin/v1/drivermetricadjustments/shift-adherence": [
    "ManageDriverMetricAdjustments"
  ],
  "POST:/api/admin/v1/drivermetricadjustments/{id}/revoke": [
    "ManageDriverMetricAdjustments"
  ],
  "/api/driver/v1/driverpenalties": [
    "ViewDriverPenalties"
  ],
  "/api/admin/v1/driverpenalties": [
    "ViewDriverPenalties"
  ],
  "POST:/api/admin/v1/driverpenalties": [
    "ManageDriverPenalties"
  ],
  "PATCH:/api/admin/v1/driverpenalties/{id}/approve": [
    "ManageDriverPenalties"
  ],
  "PATCH:/api/admin/v1/driverpenalties/{id}/reject": [
    "ManageDriverPenalties"
  ],
  "/api/driver/v1/driverrankings": [
    "ViewDriverRankings"
  ],
  "/api/driver/v1/driverrankings/current/penalties": [
    "ViewDriverPenalties"
  ],
  "/api/driver/v1/driverrankings/latest/penalties": [
    "ViewDriverPenalties"
  ],
  "POST:/api/admin/v1/driverrankings/run-manually/validate": [
    "RunDriverRankingsManually"
  ],
  "POST:/api/admin/v1/driverrankings/run-manually": [
    "RunDriverRankingsManually"
  ],
  "/api/admin/v1/driverrankings": [
    "ViewDriverRankings"
  ],
  "/api/admin/v1/driverrankings/periods": [
    "ViewDriverRankings"
  ],
  "/api/admin/v1/driverrankings/{id}": [
    "ViewDriverRankings"
  ],
  "/api/admin/v1/driverranksettings": [
    "ViewDriverRankSettings"
  ],
  "POST:/api/admin/v1/driverranksettings": [
    "ManageDriverRankSettings"
  ],
  "/api/admin/v1/driverranksettings/{id}": [
    "ViewDriverRankSettings"
  ],
  "PUT:/api/admin/v1/driverranksettings/{id}": [
    "ManageDriverRankSettings"
  ],
  "POST:/api/admin/v1/driverranksettings/{id}/activation": [
    "ManageDriverRankSettings"
  ],
  "/api/admin/v1/driverranktierconfigs": [
    "ViewDriverRankTierConfigs"
  ],
  "POST:/api/admin/v1/driverranktierconfigs": [
    "ManageDriverRankTierConfigs"
  ],
  "/api/admin/v1/driverranktierconfigs/{id}": [
    "ViewDriverRankTierConfigs"
  ],
  "PUT:/api/admin/v1/driverranktierconfigs/{id}": [
    "ManageDriverRankTierConfigs"
  ],
  "DELETE:/api/admin/v1/driverranktierconfigs/{id}": [
    "DeleteDriverRankTierConfigs"
  ],
  "POST:/api/driver/v1/driverregistrations": [
    "ManageDriverRegistrations"
  ],
  "POST:/api/admin/v1/driverregistrations/{id}/approve": [
    "ManageDriverRegistrations"
  ],
  "POST:/api/admin/v1/driverregistrations/{id}/reject": [
    "ManageDriverRegistrations"
  ],
  "/api/admin/v1/driverregistrations": [
    "ViewDriverRegistrations"
  ],
  "/api/driver/v1/drivers/current": [
    "ViewDriverCurrentOrders"
  ],
  "/api/driver/v1/drivers/current/status": [
    "ViewBranchStatusLogs"
  ],
  "PUT:/api/driver/v1/drivers/location": [
    "ManageBranchLocation"
  ],
  "/api/driver/v1/drivers/performance": [
    "ViewDriverPerformance"
  ],
  "POST:/api/admin/v1/drivers": [
    "ManageDrivers"
  ],
  "/api/admin/v1/drivers": [
    "ViewDrivers"
  ],
  "/api/admin/v1/drivers/{id}": [
    "ViewDriverDetail"
  ],
  "PUT:/api/admin/v1/drivers/{id}": [
    "ManageDrivers"
  ],
  "DELETE:/api/admin/v1/drivers/{id}": [
    "DeleteDrivers"
  ],
  "/api/admin/v1/drivers/{id}/tracking-details": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/drivers/{id}/timelines": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/drivers/{id}/sessions": [
    "ViewDriverSessions"
  ],
  "/api/admin/v1/drivers/phone-number-check": [
    "ViewDrivers"
  ],
  "/api/admin/v1/drivers/monitoring": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/drivers/available": [
    "ViewAvailableDrivers"
  ],
  "PUT:/api/admin/v1/drivers/{id}/status": [
    "ManageDrivers"
  ],
  "PUT:/api/admin/v1/drivers/{id}/teams": [
    "ManageDrivers"
  ],
  "/api/admin/v1/drivers/{id}/performance": [
    "ViewDriverPerformance"
  ],
  "/api/admin/v1/drivers/search-drivers": [
    "ViewDrivers"
  ],
  "/api/admin/v1/drivers/{id}/search-drivers": [
    "ViewDrivers"
  ],
  "/api/admin/v1/driversalaries": [
    "ViewDriverSalaries"
  ],
  "/api/admin/v1/driversalaries/{driverSalaryId}": [
    "ViewDriverSalaries"
  ],
  "/api/admin/v1/driversalaries/driver/{driverId}": [
    "ViewDriverSalaries"
  ],
  "PUT:/api/admin/v1/driversalaries/driver/{driverId}": [
    "ManageDriversSalaries"
  ],
  "/api/admin/v1/drivers/{driverId}/shift-adherence": [
    "ViewDriverShiftAdherence"
  ],
  "/api/admin/v1/drivers/{driverId}/shift-adherence/{driverShiftId}": [
    "ViewDriverShiftAdherence"
  ],
  "POST:/api/admin/v1/drivershifts/acquire": [
    "ManageDriverShifts"
  ],
  "/api/admin/v1/drivershifts": [
    "ViewDriverShifts"
  ],
  "/api/admin/v1/drivershifts/{id}": [
    "ViewDriverShifts"
  ],
  "POST:/api/admin/v1/driver-teams": [
    "ManageDriverTeams"
  ],
  "/api/admin/v1/driver-teams": [
    "ViewDriverTeams"
  ],
  "/api/admin/v1/driver-teams/{id}": [
    "ViewDriverTeamDetails"
  ],
  "PUT:/api/admin/v1/driver-teams/{id}": [
    "ManageDriverTeams"
  ],
  "DELETE:/api/admin/v1/driver-teams/{id}": [
    "DeleteDriverTeams"
  ],
  "POST:/api/admin/v1/driver-teams/{id}/drivers/{driverId}": [
    "ManageDriverTeams"
  ],
  "DELETE:/api/admin/v1/driver-teams/{id}/drivers/{driverId}": [
    "ManageDriverTeams"
  ],
  "POST:/api/admin/v1/driver-teams/{id}/channels/{channelId}": [
    "ManageDriverTeams"
  ],
  "DELETE:/api/admin/v1/driver-teams/{id}/channels/{channelId}": [
    "ManageDriverTeams"
  ],
  "POST:/api/partner/v1/external-branches/public/check": [
    "BypassOrderManualAssignAcquireChecks"
  ],
  "POST:/api/admin/v1/externalbranches/{id}/check": [
    "BypassOrderManualAssignAcquireChecks"
  ],
  "/api/client/v1/favorites/branches": [
    "ViewBranches"
  ],
  "/api/client/v1/favorites/items": [
    "ViewItems"
  ],
  "/api/client/v1/favorites/items/branches": [
    "ViewBranches"
  ],
  "/api/admin/v1/groups/{id}": [
    "ViewGroups"
  ],
  "/api/admin/v1/groups": [
    "ViewGroups"
  ],
  "/api/admin/v1/groups/{id}/users": [
    "ViewGroups"
  ],
  "/api/admin/v1/groups/{id}/phone-numbers": [
    "ViewGroups"
  ],
  "POST:/api/admin/v1/driver-earnings/reconstruction/preview": [
    "ViewDriverEarning"
  ],
  "/api/client/v1/items": [
    "ViewItems"
  ],
  "/api/client/v1/items/meals": [
    "ViewCancelMealReasons"
  ],
  "/api/admin/v1/items/{id}": [
    "ViewItemDetails"
  ],
  "PUT:/api/admin/v1/items/{id}": [
    "ManageItems"
  ],
  "DELETE:/api/admin/v1/items/{id}": [
    "DeleteItems"
  ],
  "/api/admin/v1/items": [
    "ViewItems"
  ],
  "POST:/api/admin/v1/items": [
    "ManageItems"
  ],
  "/api/admin/v1/items/discounted": [
    "ViewItems"
  ],
  "POST:/api/admin/v1/items/sync/{branchId}": [
    "SyncAlgoliaItems"
  ],
  "PUT:/api/admin/v1/items/{id}/gallery-order/{newOrder}": [
    "ManageItems"
  ],
  "PUT:/api/admin/v1/items/{id}/order": [
    "ManageItems"
  ],
  "/api/admin/v1/items/{id}/meal-tiers": [
    "ViewItemDetails"
  ],
  "PUT:/api/admin/v1/items/{id}/meal-tiers": [
    "ViewItemDetails"
  ],
  "/api/admin/v1/itemunits/{id}": [
    "ViewItemUnitDetails"
  ],
  "PUT:/api/admin/v1/itemunits/{id}": [
    "ManageItemUnits"
  ],
  "DELETE:/api/admin/v1/itemunits/{id}": [
    "DeleteItemUnits"
  ],
  "/api/admin/v1/itemunits": [
    "ViewItemUnits"
  ],
  "POST:/api/admin/v1/itemunits": [
    "ManageItemUnits"
  ],
  "/api/driver/v1/jobs/live": [
    "ViewLiveOrders"
  ],
  "/api/admin/v1/jobs/active/driver/{driverId}": [
    "ViewJobs"
  ],
  "/api/admin/v1/jobs/{jobId}/driver-estimated-route": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/jobs/{id}/shipments/routes/monitoring": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/jobs": [
    "ViewJobs"
  ],
  "/api/admin/v1/jobs/monitoring": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/jobs/{id}/monitoring": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/jobs/{id}/shipment-info": [
    "ViewShipments"
  ],
  "/api/operator/v1/mealcategories": [
    "ViewMealCategories"
  ],
  "/api/client/v1/mealcategories": [
    "ViewMealCategories"
  ],
  "/api/admin/v1/mealcategories": [
    "ViewMealCategories"
  ],
  "POST:/api/admin/v1/mealcategories": [
    "ManageMealCategories"
  ],
  "/api/admin/v1/mealcategories/all": [
    "ViewMealCategories"
  ],
  "/api/admin/v1/mealcategories/{id}": [
    "ViewMealCategoryDetails"
  ],
  "PUT:/api/admin/v1/mealcategories/{id}": [
    "ManageMealCategories"
  ],
  "DELETE:/api/admin/v1/mealcategories/{id}": [
    "DeleteMealCategories"
  ],
  "/api/admin/v1/mealcategories/{id}/items": [
    "ViewMealCategoryDetails"
  ],
  "PUT:/api/admin/v1/mealcategories/{id}/items": [
    "ManageMealCategories"
  ],
  "/api/admin/v1/mealcategories/{id}/mealtiers": [
    "ViewMealCategoryDetails"
  ],
  "PUT:/api/admin/v1/mealcategories/{id}/mealtiers": [
    "ManageMealCategories"
  ],
  "PUT:/api/admin/v1/mealcategories/{id}/order": [
    "ManageMealCategories"
  ],
  "/api/operator/v1/meals/{id}/items": [
    "ViewItems"
  ],
  "/api/operator/v1/meals/{id}/users": [
    "ViewUsers"
  ],
  "POST:/api/operator/v1/meals/branches/{mealBranchId}/accept": [
    "ViewDriverAcceptanceRate"
  ],
  "/api/operator/v1/meals": [
    "ViewCancelMealReasons"
  ],
  "/api/operator/v1/meals/monitoring": [
    "ViewMonitoring"
  ],
  "/api/driver/v1/meals/available": [
    "ViewAvailableDrivers"
  ],
  "POST:/api/driver/v1/meals/{id}/acquire": [
    "AcquireOrderToDriver"
  ],
  "/api/driver/v1/meals/items": [
    "ViewItems"
  ],
  "/api/driver/v1/meals/branches": [
    "ViewBranches"
  ],
  "POST:/api/client/v1/meals/items": [
    "ManageItems"
  ],
  "/api/client/v1/meals/actives": [
    "ChangeOrderStatusWhenIsActive"
  ],
  "/api/client/v1/meals/{id}/items": [
    "ViewItems"
  ],
  "/api/client/v1/meals": [
    "ViewCancelMealReasons"
  ],
  "POST:/api/admin/v1/meals/scheduled-programs/preview": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/scheduled-programs": [
    "ManageMeals"
  ],
  "/api/admin/v1/meals/scheduled-programs": [
    "ViewCompanies"
  ],
  "/api/admin/v1/meals/scheduled-programs/{id}": [
    "ViewOrderDetails"
  ],
  "PUT:/api/admin/v1/meals/scheduled-programs/{id}": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/scheduled-programs/{id}/cancel": [
    "ManageMeals"
  ],
  "/api/admin/v1/meals/streams": [
    "ViewCompanies"
  ],
  "/api/admin/v1/meals/streamsv2": [
    "ViewCompanies"
  ],
  "/api/admin/v1/meals": [
    "ViewCompanies"
  ],
  "/api/admin/v1/meals/monitoring": [
    "ViewCompanies"
  ],
  "/api/admin/v1/meals/{id}": [
    "ViewOrderDetails"
  ],
  "/api/admin/v1/meals/{id}/status-logs": [
    "ViewOrderDetails"
  ],
  "/api/admin/v1/meals/{id}/items": [
    "ViewOrderDetails"
  ],
  "/api/admin/v1/meals/{id}/addresses": [
    "ViewOrderDetails"
  ],
  "/api/admin/v1/meals/{id}/users": [
    "ViewOrderDetails"
  ],
  "/api/admin/v1/meals/{id}/branches": [
    "ViewOrderDetails"
  ],
  "POST:/api/admin/v1/meals/{id}/acquire": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/{id}/collecting": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/{id}/delivering": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/{id}/at-destination": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/{id}/complete": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/{id}/not-delivered": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/{id}/cancel": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/branches/{mealBranchId}/accept": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/branches/{mealBranchId}/prepared": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/branches/{mealBranchId}/driver-reached-branch": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/branches/{mealBranchId}/picked-up": [
    "ManageMeals"
  ],
  "/api/admin/v1/meals/status-can-be-updated-to": [
    "ManageMeals"
  ],
  "PUT:/api/admin/v1/meals/{id}/dates": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/{id}/broadcast": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/{id}/assign": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/{id}/unassign": [
    "ManageMeals"
  ],
  "POST:/api/admin/v1/meals/items": [
    "ManageMealItems"
  ],
  "PUT:/api/admin/v1/meals/items/{mealItemId}": [
    "ManageMealItems"
  ],
  "DELETE:/api/admin/v1/meals/items/{mealItemId}": [
    "ManageMealItems"
  ],
  "POST:/api/admin/v1/meals/{id}/tracking": [
    "WatchMeals"
  ],
  "/api/admin/v1/meals/count-by-status": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/mealtiers/{id}": [
    "ViewMealTiers"
  ],
  "PUT:/api/admin/v1/mealtiers/{id}": [
    "ManageMealTiers"
  ],
  "DELETE:/api/admin/v1/mealtiers/{id}": [
    "ManageMealTiers"
  ],
  "/api/admin/v1/mealtiers": [
    "ViewMealTiers"
  ],
  "POST:/api/admin/v1/mealtiers": [
    "ManageMealTiers"
  ],
  "/api/admin/v1/menuscreens": [
    "ViewMenuScreens"
  ],
  "POST:/api/admin/v1/menuscreens": [
    "ManageMenuScreens"
  ],
  "PUT:/api/admin/v1/menuscreens/{id}": [
    "ManageMenuScreens"
  ],
  "DELETE:/api/admin/v1/menuscreens/{id}": [
    "ManageMenuScreens"
  ],
  "POST:/api/admin/v1/migrations/merge-duplicated-users": [
    "ManageBranches"
  ],
  "/api/admin/v1/migrations/getuserzohocrmasync": [
    "ManageBranches"
  ],
  "/api/admin/v1/migrations/set-item-id": [
    "ManageBranches"
  ],
  "/api/admin/v1/monitoring/counts": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/operatorpricechanges": [
    "ViewOperatorPriceChanges"
  ],
  "/api/admin/v1/ordercancellationpolicies": [
    "ViewPanelSettings"
  ],
  "POST:/api/admin/v1/ordercancellationpolicies": [
    "ManagePanelSettings"
  ],
  "/api/admin/v1/ordercancellationpolicies/{id}": [
    "ViewPanelSettings"
  ],
  "PUT:/api/admin/v1/ordercancellationpolicies/{id}": [
    "ManagePanelSettings"
  ],
  "DELETE:/api/admin/v1/ordercancellationpolicies/{id}": [
    "ManagePanelSettings"
  ],
  "PUT:/api/admin/v1/ordercancellationpolicies/{id}/status": [
    "ManagePanelSettings"
  ],
  "/api/admin/v1/ordercancellationpolicies/history": [
    "ViewPanelSettings"
  ],
  "/api/admin/v1/orderextraitems/{id}": [
    "ViewOrderDetails"
  ],
  "PUT:/api/admin/v1/orderextraitems/{id}": [
    "ManageOrders"
  ],
  "DELETE:/api/admin/v1/orderextraitems/{id}": [
    "ManageOrders"
  ],
  "POST:/api/admin/v1/orderextraitems": [
    "ManageOrders"
  ],
  "/api/admin/v1/orderpaymenttypes": [
    "ViewOrderPaymentTypes"
  ],
  "PUT:/api/admin/v1/orderpaymenttypes/{id}": [
    "ManageOrderPaymentTypes"
  ],
  "/api/driver/v1/orders/{id}/items": [
    "ViewItems"
  ],
  "/api/driver/v1/orders/available": [
    "ViewAvailableDrivers"
  ],
  "/api/client/v1/orders/{id}/discount": [
    "ViewDiscounts"
  ],
  "/api/client/v1/orders/{orderId}/items": [
    "ViewItems"
  ],
  "/api/client/v1/orders": [
    "ViewOrders"
  ],
  "POST:/api/client/v1/orders": [
    "ManageOrders"
  ],
  "POST:/api/client/v1/orders/{id}/cancel": [
    "ManageCancelOrderReasons"
  ],
  "POST:/api/client/v1/orders/estimate": [
    "ManageEstimatedDelivery"
  ],
  "/api/admin/v1/orders/stream": [
    "ViewLiveOrders"
  ],
  "/api/admin/v1/orders/streamv2": [
    "ViewLiveOrders"
  ],
  "/api/admin/v1/orders/monitor": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/orders/drivers/{driverId}/current": [
    "ViewDriverCurrentOrders"
  ],
  "/api/admin/v1/orders/{id}": [
    "ViewOrderDetails"
  ],
  "/api/admin/v1/orders/{id}/discount": [
    "ViewOrderDetails"
  ],
  "/api/admin/v1/orders/{id}/admin-notes": [
    "ViewOrderAdminNotes"
  ],
  "/api/admin/v1/orders/{id}/invoice": [
    "ViewOrderDetails"
  ],
  "/api/admin/v1/orders/{id}/items": [
    "ViewOrderDetails"
  ],
  "PUT:/api/admin/v1/orders/{id}/items": [
    "ManageItems"
  ],
  "/api/admin/v1/orders/{id}/extra-items": [
    "ViewOrderDetails"
  ],
  "/api/admin/v1/orders": [
    "ViewOrders"
  ],
  "/api/admin/v1/orders/{id}/status-logs": [
    "ViewOrderDetails"
  ],
  "/api/admin/v1/orders/status-can-be-updated-to": [
    "ViewOrderDetails"
  ],
  "POST:/api/admin/v1/orders/{id}/deduction": [
    "UpdateOrderDeductionWhenItIsActive"
  ],
  "POST:/api/admin/v1/orders/{id}/deduction/preview": [
    "UpdateOrderDeductionWhenItIsActive"
  ],
  "POST:/api/admin/v1/orders/{id}/compensation": [
    "ManageOrderCompensation"
  ],
  "POST:/api/admin/v1/orders/{id}/approve": [
    "ChangeOrderStatusWhenIsActive"
  ],
  "POST:/api/admin/v1/orders/{orderAdminNoteId}/admin-notes": [
    "ManageOrderAdminNotes"
  ],
  "POST:/api/admin/v1/orders/{id}/accept": [
    "ChangeOrderStatusWhenIsActive"
  ],
  "PUT:/api/admin/v1/orders/admin-notes/{orderAdminNoteId}": [
    "ManageOrderAdminNotes"
  ],
  "DELETE:/api/admin/v1/orders/admin-notes/{orderAdminNoteId}": [
    "DeleteOrderAdminNotes"
  ],
  "POST:/api/admin/v1/orders/{id}/tracking": [
    "WatchOrders"
  ],
  "POST:/api/admin/v1/orders/{id}/broadcast": [
    "StartOrderSearch"
  ],
  "POST:/api/admin/v1/orders/{id}/assign": [
    "AssignOrderToDriver"
  ],
  "POST:/api/admin/v1/orders/{id}/unassign": [
    "UnassignOrderFromDriver"
  ],
  "POST:/api/admin/v1/orders/{id}/acquire": [
    "AcquireOrderToDriver"
  ],
  "POST:/api/admin/v1/orders/{id}/driver-reached-branch": [
    "ChangeOrderStatusWhenIsActive"
  ],
  "POST:/api/admin/v1/orders/{id}/picked-up": [
    "ChangeOrderStatusWhenIsActive"
  ],
  "PUT:/api/admin/v1/orders/{id}/delivering": [
    "ChangeOrderStatusWhenIsActive"
  ],
  "POST:/api/admin/v1/orders/{id}/reach-destination": [
    "ChangeOrderStatusWhenIsActive"
  ],
  "PUT:/api/admin/v1/orders/{id}/address-point": [
    "ManageOrders"
  ],
  "POST:/api/admin/v1/orders/zoho-create-invoice": [
    "ManageOrders"
  ],
  "DELETE:/api/admin/v1/orders/zoho-delete-invoice": [
    "ManageOrders"
  ],
  "POST:/api/admin/v1/orders/zoho-create-payment": [
    "ManageOrders"
  ],
  "POST:/api/admin/v1/orders/invoice-fulfillment/{invoiceFulfillmentId}/zoho-payment": [
    "ManageOrders"
  ],
  "DELETE:/api/admin/v1/orders/invoice-fulfillment/{invoiceFulfillmentId}/zoho-payment": [
    "ManageOrders"
  ],
  "DELETE:/api/admin/v1/orders/zoho-delete-payment": [
    "ManageOrders"
  ],
  "POST:/api/admin/v1/orders/zoho-apply-credit": [
    "ManageOrders"
  ],
  "/api/admin/v1/orders/count-by-status": [
    "ViewOrders"
  ],
  "/api/admin/v1/orders/{id}/compensations": [
    "ViewOrders"
  ],
  "POST:/api/admin/v1/orders/invoices/fulfillments/{fulfillmentId}/pay": [
    "ManageOrders"
  ],
  "/api/admin/v2/orders/stream": [
    "ViewLiveOrders"
  ],
  "/api/admin/v1/orderstatistics": [
    "ViewOrderStatistics"
  ],
  "/api/admin/v1/orderstatistics/summery": [
    "ViewOrderStatistics"
  ],
  "POST:/api/admin/v1/orderstatistics/migrate-to-statistics": [
    "ViewOrderStatistics"
  ],
  "/api/driver/v1/packages/available": [
    "ViewAvailableDrivers"
  ],
  "POST:/api/driver/v1/packages/{id}/acquire": [
    "AcquireOrderToDriver"
  ],
  "/api/client/v1/packages": [
    "ViewPackages"
  ],
  "POST:/api/client/v1/packages": [
    "ManagePackages"
  ],
  "POST:/api/client/v1/packages/estimate": [
    "ManageEstimatedDelivery"
  ],
  "/api/admin/v1/packages": [
    "ViewPackages"
  ],
  "/api/admin/v1/packages/{id}": [
    "ViewPackageDetails"
  ],
  "/api/admin/v1/packages/{id}/status-logs": [
    "ViewPackageDetails"
  ],
  "/api/admin/v1/packages/{id}/cargos/routes/monitoring": [
    "ViewMonitoring"
  ],
  "PUT:/api/admin/v1/packages/{id}/address": [
    "ManagePackages"
  ],
  "/api/admin/v1/packages/monitoring": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/packages/streaming": [
    "ViewStreamingPackages"
  ],
  "/api/admin/v1/packages/streamingv2": [
    "ViewStreamingPackages"
  ],
  "POST:/api/admin/v1/packages/{id}/approve": [
    "ManagePackages"
  ],
  "POST:/api/admin/v1/packages/{id}/assign": [
    "ManagePackages"
  ],
  "POST:/api/admin/v1/packages/{id}/unassign": [
    "UnassignOrderFromDriver"
  ],
  "POST:/api/admin/v1/packages/{id}/acquire": [
    "ManagePackages"
  ],
  "POST:/api/admin/v1/packages/{id}/at-source": [
    "ManagePackages"
  ],
  "POST:/api/admin/v1/packages/{id}/picked-up": [
    "ManagePackages"
  ],
  "POST:/api/admin/v1/packages/{id}/delivering": [
    "ManagePackages"
  ],
  "POST:/api/admin/v1/packages/{id}/at-destination": [
    "ManagePackages"
  ],
  "POST:/api/admin/v1/packages/{id}/complete": [
    "ManagePackages"
  ],
  "POST:/api/admin/v1/packages/{id}/not-delivered": [
    "ManagePackages"
  ],
  "POST:/api/admin/v1/packages/{id}/cancel": [
    "ManagePackages"
  ],
  "/api/admin/v1/packages/status-can-be-updated-to": [
    "ViewPackageDetails"
  ],
  "POST:/api/admin/v1/packages/{id}/tracking": [
    "WatchPackages"
  ],
  "/api/admin/v1/packages/count-by-status": [
    "ViewPackages"
  ],
  "/api/admin/v1/panelsettings": [
    "ViewPanelSettings"
  ],
  "POST:/api/admin/v1/panelsettings": [
    "ManagePanelSettings"
  ],
  "DELETE:/api/admin/v1/panelsettings/{id}": [
    "ManagePanelSettings"
  ],
  "/api/admin/v1/partners": [
    "ViewPartners"
  ],
  "POST:/api/admin/v1/partners": [
    "ManagePartners"
  ],
  "/api/admin/v1/partners/{id}": [
    "ViewPartnerDetails"
  ],
  "PUT:/api/admin/v1/partners/{id}": [
    "ManagePartners"
  ],
  "DELETE:/api/admin/v1/partners/{id}": [
    "DeletePartners"
  ],
  "/api/client/v1/paymenttypes/active": [
    "ChangeOrderStatusWhenIsActive"
  ],
  "/api/admin/v1/policies": [
    "ViewPolicies"
  ],
  "/api/driver/v1/pouches/driver/current": [
    "ViewDriverCurrentOrders"
  ],
  "/api/admin/v1/pouches/drivers/drivers/{driverId}": [
    "ViewDriverPouches"
  ],
  "/api/admin/v1/pouches/drivers/{id}": [
    "ViewDriverPouches"
  ],
  "PUT:/api/admin/v1/pouches/drivers/{id}": [
    "ManageDriverPouches"
  ],
  "/api/admin/v1/pouches/accountant/{id}": [
    "ViewAccountantPouches"
  ],
  "/api/admin/v1/pouches/drivers": [
    "ViewDriverPouches"
  ],
  "/api/admin/v1/pouches/accountants": [
    "ViewAccountantPouches"
  ],
  "/api/admin/v1/pouches/drivers/export": [
    "ExportDriverPouchFiles"
  ],
  "/api/admin/v1/pouches/accountants/export": [
    "ExportAccountantPouchFiles"
  ],
  "/api/admin/v1/pouchoperations/drivers": [
    "ViewDriverPouchOperations"
  ],
  "/api/admin/v1/pouchoperations/accountants": [
    "ViewAccountantPouchOperations"
  ],
  "/api/admin/v1/pouchoperations/drivers/round-difference": [
    "ViewDriverPouchOperations"
  ],
  "POST:/api/admin/v1/pouchoperations": [
    "WithdrawalAccountantPouch"
  ],
  "POST:/api/admin/v1/pouchoperations/self-transfer": [
    "WithdrawalDriverPouch"
  ],
  "/api/admin/v1/prizes": [
    "ViewPrizes"
  ],
  "POST:/api/admin/v1/prizes": [
    "ManagePrizes"
  ],
  "/api/admin/v1/prizes/{id}": [
    "ViewPrizeDetails"
  ],
  "PUT:/api/admin/v1/prizes/{id}": [
    "ManagePrizes"
  ],
  "DELETE:/api/admin/v1/prizes/{id}": [
    "DeletePrizes"
  ],
  "/api/admin/v1/regiondailyaverages": [
    "ViewDriverRankings"
  ],
  "/api/admin/v1/regiondeliveryrangesettings/{id}": [
    "ViewRegionDeliveryRangeSettings"
  ],
  "PUT:/api/admin/v1/regiondeliveryrangesettings/{id}": [
    "ManageRegionDeliveryRangeSettings"
  ],
  "/api/admin/v1/regiondeliveryrangesettings": [
    "ViewRegionDeliveryRangeSettings"
  ],
  "POST:/api/admin/v1/regiondeliveryrangesettings": [
    "ManageRegionDeliveryRangeSettings"
  ],
  "/api/admin/v1/driver-earnings/region-settings": [
    "ViewDriverEarning"
  ],
  "PUT:/api/admin/v1/driver-earnings/region-settings/{regionId}": [
    "ManageDriversSalaries"
  ],
  "/api/admin/v1/regionmenusettings/{regionId}": [
    "ViewMenuScreens"
  ],
  "POST:/api/admin/v1/regionmenusettings/{regionId}": [
    "ManageMenuScreens"
  ],
  "DELETE:/api/admin/v1/regionmenusettings/{regionId}/{menuScreenId}": [
    "ManageMenuScreens"
  ],
  "/api/admin/v1/reminders/orders/{orderId}/attempts": [
    "ViewOrderDetails"
  ],
  "/api/admin/v1/remindersettings": [
    "ViewReminderSettings"
  ],
  "POST:/api/admin/v1/remindersettings": [
    "ManageReminderSettings"
  ],
  "/api/admin/v1/roles/{id}": [
    "ViewRoles"
  ],
  "PUT:/api/admin/v1/roles/{id}": [
    "ManageRoles"
  ],
  "DELETE:/api/admin/v1/roles/{id}": [
    "DeleteRoles"
  ],
  "/api/admin/v1/roles": [
    "ViewRoles"
  ],
  "POST:/api/admin/v1/roles": [
    "ManageRoles"
  ],
  "POST:/api/admin/v1/salarysystems": [
    "ManageSalarySystem"
  ],
  "/api/admin/v1/salarysystems": [
    "ViewSalarySystems"
  ],
  "/api/admin/v1/salarysystems/{id}": [
    "ViewSalarySystemDetails"
  ],
  "PUT:/api/admin/v1/salarysystems/{id}": [
    "ManageSalarySystem"
  ],
  "/api/admin/v1/salemen": [
    "ViewSalesMen"
  ],
  "POST:/api/admin/v1/salemen": [
    "ManageSalesMen"
  ],
  "/api/admin/v1/salemen/{id}": [
    "ViewSalesManDetails"
  ],
  "PUT:/api/admin/v1/salemen/{id}": [
    "ManageSalesMen"
  ],
  "DELETE:/api/admin/v1/salemen/{id}": [
    "DeleteSalesMen"
  ],
  "/api/admin/v1/searchdrivers/orders/{orderId}": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/searches/orders/{orderId}": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/searches/{searchId}": [
    "ViewMonitoring"
  ],
  "POST:/api/admin/v1/searches/{searchId}/finish": [
    "FinishOrderSearch"
  ],
  "POST:/api/admin/v1/searches/orders/{orderId}/finish": [
    "FinishOrderSearch"
  ],
  "POST:/api/admin/v1/searches/meals/{mealId}/finish": [
    "FinishOrderSearch"
  ],
  "/api/admin/v1/searches/orders/{orderId}/last": [
    "ViewMonitoring"
  ],
  "/api/admin/v1/searches/orders/{orderId}/active": [
    "ViewMonitoring"
  ],
  "POST:/api/admin/v1/searchsettings/service/{serviceId}": [
    "ManageSearchSettings"
  ],
  "/api/admin/v1/searchsettings/service/{serviceId}": [
    "ViewSearchSettings"
  ],
  "DELETE:/api/admin/v1/searchsettings/service/{serviceId}": [
    "ManageSearchSettings"
  ],
  "/api/admin/v1/selections/item/{itemId}": [
    "ViewSelections"
  ],
  "PUT:/api/admin/v1/selections/item/{itemId}": [
    "ManageSelections"
  ],
  "DELETE:/api/admin/v1/selections/{id}": [
    "DeleteSelections"
  ],
  "/api/admin/v1/services/{id}": [
    "ViewServices"
  ],
  "PUT:/api/admin/v1/services/{id}": [
    "ManageServices"
  ],
  "DELETE:/api/admin/v1/services/{id}": [
    "DeleteServices"
  ],
  "/api/admin/v1/services/{id}/generic-zoho-values": [
    "ViewServices"
  ],
  "PUT:/api/admin/v1/services/{id}/generic-zoho-values": [
    "ManageServices"
  ],
  "/api/admin/v1/services": [
    "ViewServices"
  ],
  "POST:/api/admin/v1/services": [
    "ManageServices"
  ],
  "PUT:/api/admin/v1/services/{id}/disable": [
    "ManageServices"
  ],
  "/api/admin/v1/servicestatistics": [
    "ViewServiceStatistics"
  ],
  "/api/admin/v1/servicestatistics/summery": [
    "ViewServiceStatistics"
  ],
  "/api/driver/v1/shifts/available": [
    "ViewAvailableDrivers"
  ],
  "POST:/api/driver/v1/shifts/acquire": [
    "AcquireOrderToDriver"
  ],
  "POST:/api/driver/v1/shifts/release": [
    "ReleaseDriverShifts"
  ],
  "POST:/api/admin/v1/shifts/template-activation": [
    "ActivateShiftTemplates"
  ],
  "POST:/api/admin/v1/shifts": [
    "ManageShifts"
  ],
  "/api/admin/v1/shifts": [
    "ViewShifts"
  ],
  "DELETE:/api/admin/v1/shifts": [
    "DeleteShifts"
  ],
  "POST:/api/admin/v1/shifts/acquire": [
    "ManageDriverShifts"
  ],
  "POST:/api/admin/v1/shifts/release": [
    "ReleaseDriverShifts"
  ],
  "/api/admin/v1/shifts/{id}": [
    "ViewShifts"
  ],
  "PUT:/api/admin/v1/shifts/{id}": [
    "ManageShifts"
  ],
  "POST:/api/admin/v1/shifts/job-start": [
    "ActivateShiftTemplates"
  ],
  "/api/admin/v1/shifts/all": [
    "ViewShifts"
  ],
  "DELETE:/api/admin/v1/shifts/all": [
    "DeleteShifts"
  ],
  "POST:/api/admin/v1/shiftsettings": [
    "ManageShiftSettings"
  ],
  "/api/admin/v1/shiftsettings": [
    "ViewShiftSettings"
  ],
  "POST:/api/admin/v1/shifttemplates": [
    "ManageShiftTemplates"
  ],
  "/api/admin/v1/shifttemplates": [
    "ViewShiftTemplates"
  ],
  "DELETE:/api/admin/v1/shifttemplates": [
    "DeleteShiftTemplates"
  ],
  "/api/admin/v1/shifttemplates/{id}": [
    "ViewShiftTemplateDetails"
  ],
  "PUT:/api/admin/v1/shifttemplates/{id}": [
    "ManageShiftTemplates"
  ],
  "DELETE:/api/admin/v1/shifttemplates/day": [
    "DeleteShiftTemplates"
  ],
  "/api/driver/v1/shipments/earning": [
    "ViewDriverEarning"
  ],
  "/api/driver/v1/shipments": [
    "ViewShipments"
  ],
  "/api/driver/v1/shipments/activity": [
    "ViewActivityLogs"
  ],
  "/api/admin/v1/shipments": [
    "ViewShipments"
  ],
  "/api/admin/v1/shipments/driver/{driverId}/earnings": [
    "ViewShipments"
  ],
  "/api/admin/v1/shipments/{id}": [
    "ViewShipments"
  ],
  "/api/admin/v1/shipments/{id}/customer-info": [
    "ViewShipments"
  ],
  "/api/admin/v1/shipments/{id}/status-logs": [
    "ViewShipments"
  ],
  "POST:/api/admin/v1/shipments/transfer": [
    "TransferShipments"
  ],
  "/api/admin/v1/shipments/{shipmentId}/routes": [
    "ViewShipments"
  ],
  "/api/admin/v1/shipments/{shipmentId}/current-tracked-driver-route": [
    "ViewMonitoring"
  ],
  "POST:/api/admin/v1/shipments/job/{jobId}/rearrange": [
    "ManageShipments"
  ],
  "POST:/api/admin/v1/shipments/{id}/recalculate-driver-earning": [
    "ReCalculateDriverEarnings"
  ],
  "/api/admin/v1/shipments/job/{jobId}/shipmentids": [
    "ViewShipments"
  ],
  "/api/admin/v1/shipments/{id}/monitoring": [
    "ViewMonitoring"
  ],
  "POST:/api/admin/v1/shipments/{id}/cancel": [
    "CancelShipments"
  ],
  "POST:/api/admin/v1/shipments/{id}/sync-pouch-operation": [
    "WithdrawalDriverPouch"
  ],
  "/api/client/v1/showcases": [
    "ViewShowcases"
  ],
  "/api/admin/v1/showcases/{id}/branches": [
    "ViewShowcaseDetails"
  ],
  "PUT:/api/admin/v1/showcases/{id}/branches": [
    "ManageShowcases"
  ],
  "/api/admin/v1/showcases/{id}/items": [
    "ViewShowcaseDetails"
  ],
  "PUT:/api/admin/v1/showcases/{id}/items": [
    "ManageShowcases"
  ],
  "/api/admin/v1/showcases/{id}": [
    "ViewShowcaseDetails"
  ],
  "PUT:/api/admin/v1/showcases/{id}": [
    "ManageShowcases"
  ],
  "DELETE:/api/admin/v1/showcases/{id}": [
    "DeleteShowcases"
  ],
  "/api/admin/v1/showcases": [
    "ViewShowcases"
  ],
  "POST:/api/admin/v1/showcases": [
    "ManageShowcases"
  ],
  "PUT:/api/admin/v1/showcases/{id}/order": [
    "ManageShowcases"
  ],
  "PUT:/api/admin/v1/showcases/{id}/branches/order": [
    "ManageShowcases"
  ],
  "/api/admin/v1/showcaseshifts/{showcaseId}": [
    "ViewShowcaseDetails"
  ],
  "PUT:/api/admin/v1/showcaseshifts/{showcaseId}": [
    "ManageShowcases"
  ],
  "/api/client/v1/spinwheels": [
    "ViewSpinWheels"
  ],
  "POST:/api/client/v1/spinwheels/{id}/spin": [
    "ManageSpinWheel"
  ],
  "/api/admin/v1/spinwheels": [
    "ViewSpinWheels"
  ],
  "POST:/api/admin/v1/spinwheels": [
    "ManageSpinWheel"
  ],
  "/api/admin/v1/spinwheels/{id}": [
    "ViewSpinWheelDetails"
  ],
  "PUT:/api/admin/v1/spinwheels/{id}": [
    "ManageSpinWheel"
  ],
  "DELETE:/api/admin/v1/spinwheels/{id}": [
    "DeleteSpinWheel"
  ],
  "/api/admin/v1/spinwheels/{id}/users": [
    "ViewSpinWheelDetails"
  ],
  "PUT:/api/admin/v1/spinwheels/{id}/users": [
    "ManageSpinWheel"
  ],
  "/api/admin/v1/spinwheels/{id}/prizes": [
    "ViewSpinWheelDetails"
  ],
  "PUT:/api/admin/v1/spinwheels/{id}/prizes": [
    "ManageSpinWheel"
  ],
  "/api/admin/v1/spinwheels/{id}/branches": [
    "ViewSpinWheelDetails"
  ],
  "PUT:/api/admin/v1/spinwheels/{id}/branches": [
    "ManageSpinWheel"
  ],
  "/api/admin/v1/spinwheels/{id}/regions": [
    "ViewSpinWheelDetails"
  ],
  "PUT:/api/admin/v1/spinwheels/{id}/regions": [
    "ManageSpinWheel"
  ],
  "POST:/api/driver/v1/supportmessages/admin": [
    "ManageOrderAdminNotes"
  ],
  "/api/driver/v1/supportmessages": [
    "ViewSupportMessages"
  ],
  "POST:/api/client/v1/supportmessages": [
    "ManageSupportMessage"
  ],
  "/api/client/v1/supportmessages": [
    "ViewSupportMessages"
  ],
  "/api/admin/v1/supportmessages/all": [
    "ViewSupportMessages"
  ],
  "/api/admin/v1/supportmessages/direct": [
    "ViewSupportMessages"
  ],
  "POST:/api/admin/v1/supportmessages/{senderUserId}/read": [
    "ManageSupportMessage"
  ],
  "POST:/api/admin/v1/supportmessages/driver/message": [
    "ManageSupportMessage"
  ],
  "POST:/api/admin/v1/syncexternalbranchjobs": [
    "CreateSyncExternalBranchJobs"
  ],
  "/api/admin/v1/syncexternalbranchjobs": [
    "ViewSyncExternalBranchJobs"
  ],
  "/api/admin/v1/syncexternalbranchjobs/{id}/status-logs": [
    "ViewSyncExternalBranchJobs"
  ],
  "POST:/api/admin/v1/syncexternalbranchjobs/{id}/cancel": [
    "CancelSyncExternalBranchJobs"
  ],
  "/api/admin/v1/translation/check-untranslated": [
    "ViewTranslations"
  ],
  "/api/admin/v1/translation": [
    "ViewTranslations"
  ],
  "PUT:/api/admin/v1/translation/{id}": [
    "ManageTranslations"
  ],
  "/api/client/v1/trendingsearches": [
    "ViewTrendingSearches"
  ],
  "/api/admin/v1/trendingsearches": [
    "ViewTrendingSearches"
  ],
  "POST:/api/admin/v1/trendingsearches": [
    "ManageTrendingSearch"
  ],
  "/api/admin/v1/trendingsearches/{id}": [
    "ViewTrendingSearchDetails"
  ],
  "PUT:/api/admin/v1/trendingsearches/{id}": [
    "ManageTrendingSearch"
  ],
  "DELETE:/api/admin/v1/trendingsearches/{id}": [
    "DeleteTrendingSearch"
  ],
  "/api/admin/v1/useraddresses": [
    "ViewUserAddress"
  ],
  "PUT:/api/admin/v1/useraddresses/{id}": [
    "ManageUserAddress"
  ],
  "POST:/api/admin/v1/useraddresses/update-missing-location-names": [
    "ManageUserAddress"
  ],
  "/api/admin/v1/usernotes/{id}": [
    "ViewCustomerNotes"
  ],
  "PUT:/api/admin/v1/usernotes/{id}": [
    "ManageCustomerNotes"
  ],
  "DELETE:/api/admin/v1/usernotes/{id}": [
    "DeleteCustomerNotes"
  ],
  "/api/admin/v1/usernotes/users/{userId}": [
    "ViewCustomerNotes"
  ],
  "/api/admin/v1/usernotes": [
    "ViewCustomerNotes"
  ],
  "POST:/api/admin/v1/usernotes": [
    "ManageCustomerNotes"
  ],
  "/api/admin/v1/usernotes/users/{userId}/latest": [
    "ViewCustomerNotes"
  ],
  "/api/client/v1/userorderratereasons": [
    "ViewUserOrderRateReasons"
  ],
  "/api/admin/v1/userorderratereasons/{id}": [
    "ViewUserOrderRateReasons"
  ],
  "PUT:/api/admin/v1/userorderratereasons/{id}": [
    "ManageUserOrderRateReasons"
  ],
  "DELETE:/api/admin/v1/userorderratereasons/{id}": [
    "DeleteUserOrderRateReasons"
  ],
  "/api/admin/v1/userorderratereasons": [
    "ViewUserOrderRateReasons"
  ],
  "POST:/api/admin/v1/userorderratereasons": [
    "ManageUserOrderRateReasons"
  ],
  "/api/client/v1/userorderrates/{orderId}/rate": [
    "ViewUserOrderRates"
  ],
  "POST:/api/client/v1/userorderrates/{orderId}/rate": [
    "ManageUserOrderRateReasons"
  ],
  "/api/admin/v1/userorderrates": [
    "ViewUserOrderRates"
  ],
  "POST:/api/admin/v1/userorderrates/{userOrderRateId}/approve": [
    "ManageUserOrderRates"
  ],
  "POST:/api/admin/v1/userorderrates/{userOrderRateId}/hide-out-comment": [
    "ManageUserOrderRates"
  ],
  "/api/operator/v1/users/current/roles": [
    "ViewRoles"
  ],
  "/api/operator/v1/users/current": [
    "ViewDriverCurrentOrders"
  ],
  "/api/driver/v1/users/current": [
    "ViewDriverCurrentOrders"
  ],
  "/api/driver/v1/users/current/roles": [
    "ViewRoles"
  ],
  "/api/client/v1/users/current/roles": [
    "ViewRoles"
  ],
  "/api/client/v1/users/current": [
    "ViewDriverCurrentOrders"
  ],
  "/api/admin/v1/users/current": [
    "ViewDriverCurrentOrders"
  ],
  "/api/admin/v1/users/current/roles": [
    "ViewRoles"
  ],
  "/api/admin/v1/users/{id}": [
    "ViewUsers"
  ],
  "/api/admin/v1/users/{id}/order-summary": [
    "ViewUsers"
  ],
  "/api/admin/v1/users/{id}/roles": [
    "ViewUserRoles"
  ],
  "PUT:/api/admin/v1/users/{id}/roles": [
    "ManageUserRoles"
  ],
  "/api/admin/v1/users": [
    "ViewUsers"
  ],
  "/api/admin/v1/users/by-ids": [
    "ViewUsers"
  ],
  "/api/admin/v1/users/count": [
    "ViewUsers"
  ],
  "POST:/api/admin/v1/users/send-create-user-request": [
    "ManageUsers"
  ],
  "POST:/api/admin/v1/users/{userId}/send-update-user-request": [
    "ManageUsers"
  ],
  "PUT:/api/admin/v1/users/{id}/vip": [
    "ManageUserVip"
  ],
  "POST:/api/admin/v1/vehicletemplates": [
    "ManageVehicles"
  ],
  "/api/admin/v1/vehicletemplates": [
    "ViewVehicles"
  ],
  "/api/admin/v1/vehicletemplates/{id}": [
    "ViewVehicles"
  ],
  "PUT:/api/admin/v1/vehicletemplates/{id}": [
    "ManageVehicles"
  ],
  "DELETE:/api/admin/v1/vehicletemplates/{id}": [
    "DeleteVehicles"
  ],
  "/api/admin/v1/venders/{id}": [
    "ViewVenderDetails"
  ],
  "PUT:/api/admin/v1/venders/{id}": [
    "ManageVenders"
  ],
  "DELETE:/api/admin/v1/venders/{id}": [
    "DeleteVenders"
  ],
  "/api/admin/v1/venders": [
    "ViewVenders"
  ],
  "POST:/api/admin/v1/venders": [
    "ManageVenders"
  ],
  "POST:/api/admin/v1/zohos/create-branch": [
    "ManageUsers"
  ],
  "POST:/api/admin/v1/zohos/update-branch": [
    "ManageUsers"
  ],
  "POST:/api/admin/v1/zohos/items/submit-to-zoho": [
    "ManageItems"
  ],
  "POST:/api/admin/v1/zohos/items/update-on-zoho": [
    "ManageItems"
  ],
  "POST:/api/admin/v1/zohos/invoices/by-date": [
    "ManageOrders"
  ],
  "POST:/api/admin/v1/zohos/invoices": [
    "ManageOrders"
  ],
  "DELETE:/api/admin/v1/zohos/invoices": [
    "ManageOrders"
  ],
  "POST:/api/admin/v1/zohos/payments/by-date": [
    "ManageOrders"
  ],
  "POST:/api/admin/v1/zohos/payments": [
    "ManageOrders"
  ],
  "DELETE:/api/admin/v1/zohos/payments": [
    "ManageOrders"
  ],
  "POST:/api/admin/v1/zohos/apply-payments-by-date": [
    "ManageOrders"
  ],
  "POST:/api/admin/v1/zohos/apply-payments": [
    "ManageOrders"
  ],
  "POST:/api/admin/v1/zohos/invoice-fulfillments/{id}/payment": [
    "ManageOrders"
  ],
  "DELETE:/api/admin/v1/zohos/invoice-fulfillments/{id}/payment": [
    "ManageOrders"
  ],
  "POST:/api/admin/v1/zohos/packages/invoices": [
    "ManagePackages"
  ],
  "DELETE:/api/admin/v1/zohos/packages/invoices": [
    "ManagePackages"
  ],
  "POST:/api/admin/v1/zohos/packages/payments": [
    "ManagePackages"
  ],
  "DELETE:/api/admin/v1/zohos/packages/payments": [
    "ManagePackages"
  ],
  "POST:/api/admin/v1/zohos/packages/apply-payments": [
    "ManagePackages"
  ],
  "POST:/api/admin/v1/zones": [
    "ManageRegionZones"
  ],
  "/api/admin/v1/zones/regions/{regionId}": [
    "ManageRegionZones"
  ],
  "DELETE:/api/admin/v1/zones/{id}": [
    "ManageRegionZones"
  ],
  "PUT:/api/admin/v1/zones/{id}/active": [
    "ManageRegionZones"
  ]
}

/**
 * Extracts the URL pattern from the request options
 */
function extractUrlPattern(options: ApiRequestOptions): string {
  const method = options.method?.toUpperCase()
  const url = options.url
  
  // Remove API version placeholder
  let pattern = url.replace('{api-version}', 'v1')
  
  // Replace path parameters with placeholders
  if (options.path) {
    Object.keys(options.path).forEach(key => {
      pattern = pattern.replace(`{${key}}`, `{${key}}`)
    })
  }
  
  // Add method prefix for non-GET requests
  if (method && method !== 'GET') {
    pattern = `${method}:${pattern}`
  }
  
  return pattern
}

/**
 * Checks if the user has the required policies for the request
 */
export function checkPolicyAccess(options: ApiRequestOptions, baseUrl: string): boolean {
  const currentUserStore = useCurrentUserStore()
  const toastStore = useToastStore()
  
  // Skip policy check if user data is not loaded yet
  if (!currentUserStore.allDataLoaded || !currentUserStore.allPolicies) {
    return true
  }
  
  const urlPattern = extractUrlPattern(options)
  
  // Determine which policy mapping to use based on base URL
  let policyMapping: PolicyMapping
  if (baseUrl.includes('auth')) {
    policyMapping = authPolicyMapping
  } else if (baseUrl.includes('market')) {
    policyMapping = marketPolicyMapping
  } else {
    // If we can't determine the service, allow the request
    return true
  }
  
  // Find matching policy requirements
  let requiredPolicies: string[] = []
  
  // First try exact match
  if (policyMapping[urlPattern]) {
    requiredPolicies = policyMapping[urlPattern]
  } else {
    // Try to find a pattern match
    for (const [pattern, policies] of Object.entries(policyMapping)) {
      if (pattern.includes('{') && pattern.includes('}')) {
        // Convert pattern to regex
        const regexPattern = pattern
          .replace(/\{[^}]+\}/g, '[^/]+') // Replace {param} with regex
          .replace(/\//g, '\\/') // Escape slashes
        const regex = new RegExp(`^${regexPattern}$`)
        
        if (regex.test(urlPattern)) {
          requiredPolicies = policies
          break
        }
      }
    }
  }
  
  // If no policies are required, allow the request
  if (requiredPolicies.length === 0) {
    return true
  }
  
  // Check if user has all required policies
  const hasAllPolicies = requiredPolicies.every(policy => 
    currentUserStore.allPolicies.includes(policy)
  )
  
  if (!hasAllPolicies) {
    const missingPolicies = requiredPolicies.filter(policy => 
      !currentUserStore.allPolicies.includes(policy)
    )
    
    toastStore.updateToastState({
      severity: 'error',
      summary: 'Access Denied',
      detail: `You don't have permission to perform this action. Required policies: ${missingPolicies.join(', ')}`,
      position: 'top-right'
    })
    
    return false
  }
  
  return true
}

/**
 * Creates a policy interceptor function that can be used in request handlers
 */
export function createPolicyInterceptor(baseUrl: string) {
  return function policyInterceptor(options: ApiRequestOptions): boolean {
    return checkPolicyAccess(options, baseUrl)
  }
}
